import React from 'react'

const TContext = React.createContext()

export default TContext